import React from 'react';
import { useLDClient } from 'launchdarkly-react-client-sdk';
import { Navigate } from 'react-router-dom';
import { useAllFlags } from '../hooks/useAllFlags';
import type { LaunchDarklyFlags } from '../types/launch-darkly';

interface FlagProtectedRouteProps {
  flag: keyof LaunchDarklyFlags;
  children: React.ReactNode;
  redirectTo?: string;
}

export const FlagProtectedRoute: React.FC<FlagProtectedRouteProps> = ({
  flag,
  children,
  redirectTo = '/dashboard/metrics',
}) => {
  const ldClient = useLDClient();
  const { ld } = useAllFlags();

  if (!ldClient) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-primary"></div>
      </div>
    );
  }

  if (!ld[flag]) {
    return <Navigate to={redirectTo} replace />;
  }

  return <>{children}</>;
};
